import { render, staticRenderFns } from "./CreateNewConsolidation.vue?vue&type=template&id=ef221a40&scoped=true&"
import script from "./CreateNewConsolidation.vue?vue&type=script&lang=js&"
export * from "./CreateNewConsolidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef221a40",
  null
  
)

export default component.exports